/**
 * Created by WangPing on 2019/7/24.
 * banner模板与`sdk`交互封装
 */

'use strict'

import util from './util.js'

export default class Interactive{
    constructor(hybirdEventClass){
        this.hybirdEventClass = hybirdEventClass;
        this.points = {};
        this.campaignId = ''
    }
    /**
     * onJSBridgeConnect，h5与sdk协议握手
     * @param cb
     */
    onJSBridgeConnected(cb) {
        document.addEventListener('onJSBridgeConnected', function (res) {
            cb&&cb(res)
        }, false)
    }
    /**
     * 获取 SDK BridgeContext 的上下文
     * VideoBridge 需要注意的版本兼容问题:
     * 1. Android 9.6.0 下根节点有 {campaignList, appSetting, unitSetting, device, sdkSetting}, 但没有 {sdk_info, unit_id} 属性
     * 2. Android 8.13.0 下根节点只有 {campaignList, sdk_info, unitSetting, device, sdkSetting}, 没有 {appSetting, unit_id} 属性
     * @param succ 成功回调
     * @param err 失败回调
     * @param complete 无论成功或者失败都会执行的回调
     */
    getBridgeContext ({succ = ()=>{}, err = ()=>{}, complete = ()=>{}}) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'init',
            params: {
                pageNo: 1,
                exclude_ids: []
            },
            succ: function (res) {
                console.log('common: get VideoBridge Context success => ', res)
                if (res && res.campaignList && res.campaignList.length) {
                    succ(res)
                } else {
                    // util.noDataTips()
                }
                complete(res)
            },
            err: function (err) {
                console.error('common: get VideoBridge Context error', err)
                err(err)
                complete(err)
            }
        })
    }
    /**
     * H5渲染完成通知sdk，返回对象，成功 {code:1}
     * @param type 1 ready  2 not ready
     * @param cb
     */
    isReadyStatus(isReady = 1, cb){
        console.log("isReady:"+isReady)
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'readyStatus',
            params: {
                isReady
            },
            succ: function (res) {
                if(res.code === 0){
                    cb && cb(res)
                }
            },
            err: function () {

            }
        })
    }
    /**
     * 监听webviewshow事件
     * @param cb
     * @param bridgecontext  传入v3接口返回的对象
     */
    webviewshow(cb,bridgecontext) {
        const _this = this;
        document.addEventListener('webviewshow', function(res){
            console.log("进入webview")
            _this.points = res&&res.param || {};
            console.log('_this.points:',_this.points)
            console.log("webviewshow",res)
            cb&&cb();
            // iOS 下用户滑动时阻止页面回弹
            if (util.device().isiOS) {
                _this.toggleBounces()
            }
        }, false)
    }
    /**
     * 上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
     * @param prams [{type: '', url: only_impression_url}]
     * @param prams [{type: imp_ua, url: impression_url}]
     */
    reportUrls(params) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'reportUrls',
            params: params,
            succ: function (res) {
            },
            err: function (err) {
                // util.tips('Sorry, network error...')
            }
        })
    }
    /**
     * 安卓上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
     * 安卓 js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
     * @param prams [{type: '', url: only_impression_url}]
     * @param prams [{type: imp_ua, url: impression_url}]
     */
    reportUrlsAndroid(prams, index) {
        if(index >= prams.length) {console.log("index没有大于length"); return}
        const _this =this;
        console.log("开始reporturl")
        util.hybirdEvent({
            sClass: _this.hybirdEventClass,
            hybirdFn: 'reportUrls',
            params: [prams[index]],
            succ: function (res) {
                console.log("再次上报下一个")
                _this.reportUrlsAndroid(prams, ++index)
            },
            err: function (err) {
                console.log(err)
            }
        })
    }
    /**
     * 点击 js 跳转 调 native,+点击宏坐标，banner宏坐标按照后端返回参数计算而得
     * @param {object} bridgeContext v3接口返回的所有信息
     * @param {object} campaignMap 以id属性保存的campaign信息,点击时传入的campaign对象
     * @param type `1`是安装 `2`是关闭
     * @param cb 回调函数
     * @param template 模板类型，'banner','endcard'或其他
     * @param {boolean} autoClick 是否自动storekit
     * @param {boolean} isFromMoreOffer 当前点击是否来自 more offer, 而非主 offer
     * @param {number} currentOrientation 当前屏幕方向
     */
    click({bridgeContext,campaignMap,type = 1, cb,template,autoClick=false,isFromMoreOffer,currentOrientation}) {
        let defaultCampaign = {};
        if(campaignMap){
            defaultCampaign = Object.assign(defaultCampaign,campaignMap)
        }else {
            let campaignId = this.getAttribute('campaignId')
            if (!campaignId) return
            defaultCampaign = Object.assign(defaultCampaign, campaignMap[campaignId])
        }
        // 用于避免安卓参数过长被截断的问题
        if (util.device().isAndroid) {
            defaultCampaign = util.getParams2Native(defaultCampaign);
        }
        try {
            // click_url 替换
            let clickPosition = util.getMousePosition(event);
            let _data = bridgeContext;
            const _scale = _data.device?_data.device.scale:"" || window.devicePixelRatio;
            if(template === 'banner'){
                if (util.device().isAndroid){ // 安卓startX,startY返回dp需要乘scale，返回px则不乘scale，这里返回px,本身点击坐标需要乘scale
                    clickPosition.x = +clickPosition.x * _scale + (Number(this.points.startX));
                    clickPosition.y = +clickPosition.y * _scale + (Number(this.points.startY));
                }else{
                    clickPosition.x = (+clickPosition.x + (Number(this.points.startX))) * _scale;
                    clickPosition.y = (+clickPosition.y + (Number(this.points.startY))) * _scale;
                }
            }else{
                clickPosition.x = clickPosition.x * _scale;
                clickPosition.y = clickPosition.y * _scale;
            }
            clickPosition.scale = _scale
            //  如果是自动storekit，重置坐标
            if(autoClick){
                clickPosition.x = -999;
                clickPosition.y = -999;
                defaultCampaign = this.setStorekitStatus(defaultCampaign,isFromMoreOffer);
            }
            // 设置clickurl
            defaultCampaign = this.setClickUrl(defaultCampaign, clickPosition,_data);
            // 设置noticeurl坐标宏替换
            defaultCampaign = this.setNoticeUrl(defaultCampaign, clickPosition,autoClick,currentOrientation)
        } catch (error) {
            console.log(error)
        }
        // 安卓一定要在组装defaultCampaign之前格式化
        if (util.device().isAndroid){
            defaultCampaign = util.getParams2Native(defaultCampaign);
        }
        // 如果是banner模板需要组装defaultCampaign
        if(template === 'banner'){
            defaultCampaign = {
                type: 1,
                pt: defaultCampaign
            }
        }
        // ios针对组装后的defaultCampaign 进行encode
        if (util.device().isiOS) {
            defaultCampaign = encodeURIComponent(JSON.stringify(defaultCampaign))
        }
        // 下载跳转：banner模板，播放模板全部用click接口，banner的class为banner,播放模板VideoBridge
        if(template === 'banner'){
            util.hybirdEvent({
                sClass: this.hybirdEventClass,
                hybirdFn: 'click',
                params: defaultCampaign,
                succ: function (res) {
                    console.log(res)
                },
                err: function (err) {
                    console.log(err)
                }
            })
        }else{
            // 其他模板用install(比如endcard模板)，RewardJs-install
            util.hybirdEvent({
                sClass: this.hybirdEventClass,
                hybirdFn: 'install',
                params: defaultCampaign,
                succ: function (res) {
                    console.log(res)
                },
                err: function (err) {
                    console.log(err)
                }
            })
        }
    }
    /**
     * 拼接click_url
     * @param {object} defaultCampaign
     * @param {object} clickPosition 点击坐标对象
     * @param {object} bridgeContext v3接口上下文
     */
    setClickUrl(defaultCampaign, clickPosition,bridgeContext) {
        let _data = bridgeContext;
        const _scale = clickPosition.scale;
        const cdnate_cfg = _data.appSetting.cdnate_cfg;
        let device_width = '';
        let device_height = '';
        if(_data.device){ // 安卓sdk 9.7.0 及以下不返回device字段
            device_width = _data.device.screen_width?_data.device.screen_width:"";
            device_height = _data.device.screen_height?_data.device.screen_height:"";
            if (util.device().isiOS) {
                device_width = (_data.device.device_width?_data.device.device_width:0)* _scale;
                device_height = (_data.device.device_width?_data.device.device_width:0) * _scale;
            }
        }
        let click_url = defaultCampaign.click_url;
        let rel = /.+:\/\/(.*?)\//;
        let relhost = rel.exec(click_url)
        let host =  relhost? relhost[1] : '';
        let tar = {
            x: parseInt(clickPosition.x),
            y: parseInt(clickPosition.y),
            width: parseInt(device_width || window.screen.width),
            height: parseInt(device_height || window.screen.height)
        }

        if(cdnate_cfg && cdnate_cfg[host]){
            let item = cdnate_cfg[host];
            for(let k in item){
                let arr = item[k]
                for(let i=0;i<arr.length;i++){
                    click_url = click_url.replace(new RegExp(arr[i],'g'), tar[k])
                }
            }
        }
        defaultCampaign.click_url = click_url
        return defaultCampaign
    }
    /**
     * 拼接notice_url，点击坐标宏上报拼接
     * @param {object} defaultCampaign,campaign对象
     * @param {object} clickPosition 点击坐标对象 ，包括x,y,scale
     * @param {boolean} autoClick 是否为自动storekit
     * @param {number} currentOrientation 屏幕方向 1  竖屏，2 横屏
     */
    setNoticeUrl(defaultCampaign, clickPosition, autoClick,currentOrientation){
        let notice_url = defaultCampaign.notice_url;
        // 以下为所有点击坐标宏需要上报的参数，先删除，再重新拼接
        notice_url = util.delParam(defaultCampaign.notice_url, 'click_x');
        notice_url = util.delParam(notice_url, 'click_y');
        notice_url = util.delParam(notice_url, 'click_ori');
        notice_url = util.delParam(notice_url, 'click_senario');
        notice_url = util.delParam(notice_url, 'click_scale');
        notice_url = util.delParam(notice_url, 'webviewStartX');
        notice_url = util.delParam(notice_url, 'webviewStartY');
        notice_url = util.delParam(notice_url, 'webviewWidth');
        notice_url = util.delParam(notice_url, 'webviewHeight');
        notice_url += `&webviewWidth=${document.body.clientWidth * clickPosition.scale}&webviewHeight=${document.body.clientHeight * clickPosition.scale}`;
        notice_url += `&webviewStartX=${Number(this.points.startX)}&webviewStartY=${Number(this.points.startY)}`;
        if(!autoClick){//只有在不是自动storekit的情况下，拼接横纵坐标和方向
            let ori = currentOrientation || (window.innerWidth && window.innerHeight && (window.innerWidth < window.innerHeight ? 1 : 2))
            notice_url += `&click_x=${clickPosition.x}&click_y=${clickPosition.y}&click_ori=${ori}`;
        }
        if (util.device().isAndroid) {//安卓额外拼接scale
            notice_url +='&click_scale='+clickPosition.scale;
        }
        let isAutoClick = autoClick ? 2 : 0;//这个变量为了传click_senario
        notice_url += `&click_senario=${isAutoClick}`;//click_senario=0 表示不是自动storekit，2 是自动storekit
        defaultCampaign.notice_url = notice_url;
        return defaultCampaign
    }
    /**
     * 自动storekit坐标拼接
     * @param {object} defaultCampaign
     * @param {boolean} isFromMoreOffer 是否为多offer
     */
    setStorekitStatus(defaultCampaign,isFromMoreOffer) {
        // isFromMoreOffer 用来标识是否当前点击是否来自底部推荐位
        // 由于 SDK 暂时只支持主 offer 的 storekit 预加载, 所以点击底部推荐位时, needStorekit 应始终为 false,
        // 避免点击底部推荐位加载 storekit 失败, 又不跳转外部 App Store 的问题
        // 当needStorekit = 1的时候，如果ios判断不能出storekit,则什么也不做，否则跳。
        defaultCampaign.needStorekit = !isFromMoreOffer ? 1 : 0;
        return defaultCampaign
    }
    /**
     * 展示统计 （ 只有offer展示才上报 ）,向sdk传展示的offer的 cid
     * prams ['cid1','cid2']
     *
     */
    sendImpressions(bridgeContext) {
        let arr = bridgeContext.campaignList.map(function(item){
            return item.id
        })
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'sendImpressions',
            params: arr,
            succ: function (res) {
                console.log("campaignid上报成功")
            },
            err: function (err) {
                console.log("campaignid上报失败")
                console.log(err)
            }
        })
    }
    /**
     * pv统计 无论几个offer都只上报一次，only_impression_url
     */
    reportPv(bridgecontext){
        let arr = [{
            url: this.iosEnCodeURL(bridgecontext.campaignList[0]['only_impression_url'])
        }]
        // 安卓 会超10240，所以对安卓进行拆分，多次上报
        if(util.device().isAndroid){
            this.reportUrlsAndroid(arr, 0)
        }else{
            this.reportUrls(arr)
        }
    }
    /**
     * 上报Offer impression_url,ad_tracking.impression, 一个offer展示一次上报一次，每个offer只上报一次
     */
    reportOfferImpression(bridgecontext){
        let arr = [];
        bridgecontext.campaignList.forEach((offer)=>{
            arr.push({
                type: offer['imp_ua'],
                url: this.iosEnCodeURL(offer['impression_url'])
            })
            const adTrackingImpression = offer.ad_tracking?offer.ad_tracking.impression:"";
            if(adTrackingImpression && Array.isArray(adTrackingImpression) && adTrackingImpression.length>0){
                adTrackingImpression.forEach((item)=>{
                    arr.push({
                        url: this.iosEnCodeURL(item)
                    })
                })
            }else if(adTrackingImpression && typeof adTrackingImpression){
                arr.push({
                    url: this.iosEnCodeURL(adTrackingImpression)
                })
            }
        })
        //安卓js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
        if(util.device().isAndroid){
            console.log("isAndroid,准备上报安卓impression")
            this.reportUrlsAndroid(arr, 0)
        }else{
            this.reportUrls(arr)
        }
    }
    /**
     * ios编码url
     */
    iosEnCodeURL(url){
        if(util.device().isiOS){
            return encodeURIComponent(url)
        }
        return url
    }
    /**
     * 初始化banner关闭按钮
     * @param bridgeContext v3返回的数据
     * @param bridgeContext.sdkSetting.dev_close_state ，1表示开发者设置为展示，2表示开发者设置为关闭，0表示开发者未设置
     */
    initBannerCloseBtn(bridgeContext){
        let state = bridgeContext.sdkSetting.dev_close_state;
        if(state == 1){
            this.toggleCloseBtn(1)
        }else if(state == 2){
            this.toggleCloseBtn(2)
        }else{
            this.findFromUnitsetting(bridgeContext)
        }
    }
    /**
     * 判断 bridgeContext.unitSetting.closeBtn的值
     * @param bridgeContext v3返回的数据
     * @param 1为开，其他全部为关
     */
    findFromUnitsetting(bridgeContext){
        let state = bridgeContext.unitSetting.closeBtn;
        if(state == 1){
            this.toggleCloseBtn(1)
        }else{
            this.toggleCloseBtn(2)
        }
    }
    /**
     * 出现关闭按钮
     * @param state 1 为默认出现， 2 为隐藏
     * @param cb
     */
    toggleCloseBtn(state = 1, cb) {
        console.log('toggleCloseBtn: ', state)
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'toggleCloseBtn',
            params: {
                state // 出现
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function () {
            }
        })
    }
    /**
     * 页面关闭 - 如果 close_alert 为 1, 则 SDK 会在调用此方法时, 先展示一个原生的确认弹窗
     */
    triggerCloseBtn(state = 'click') {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'triggerCloseBtn',
            params: {
                state
            },
            succ: function (res) {
                //document.write(res);
                if (res && util.device().isAndroid) {

                } else {

                }
            },
            err: function () {
                util.tips('Sorry, network error...')
            }
        });
    }

    /**
     * IOS 控制下拉页面回弹
     *
     */
    toggleBounces(state = 0, cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'toggleBounces',
            params: {
                state // 关闭反弹
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function () {

            }
        })
    }

    /**
     * 初始化endcard关闭按钮，这个及以下方法暂没有使用到
     * @param state 1 为默认出现， 2 为隐藏
     * @param cb
     */
    initEndcardCloseBtn(bridgeContext) {
        console.log("准备出关闭按钮")
        const _this = this;
        // setTimeout 在 android webview 中偶尔无法被成功调用, 而且一旦无法成功调用,
        // 则在结束程序之前, 这个 webview 中的 setTimeout 会一直处于无法调用的状态
        // 所以这里临时针对安卓的 endcard_url(zip 包类型), 默认直接展示关闭按钮,
        // 不再遵循 setting 默认延迟 1 秒的控制, 以缓解该问题
        // PS: end_screen_url(在线 url 类型) 由于有 SDK 负责出关闭按钮, 所以在线 url 的逻辑保持不变
        // REF: http://jira.mobvista.com/browse/MTGHYB-161
        if (util.isFromZip && util.device().isAndroid) {
            _this.toggleCloseBtn()
            return
        }
        let close_button_delay
        // 关闭按钮出现倒计时
        if (bridgeContext && bridgeContext.unitSetting) {
            close_button_delay = bridgeContext.unitSetting.close_button_delay;
        }
        console.log('初始化关闭按钮：',bridgeContext)
        if (close_button_delay >= 0) {
            setTimeout(function () {
                _this.toggleCloseBtn()
                console.log('close_button_delay>0:'+close_button_delay)
            }, close_button_delay * 1000)
        } else if (close_button_delay === -1) {
            console.log("关闭按钮 -1")
            // SDK 在 -1 时有额外处理逻辑, H5 不做任何处理
        } else {
            console.log('close_button_delay默认:'+close_button_delay)
            setTimeout(function () {
                _this.toggleCloseBtn();
            }, 1000)
        }
    }

    /**
     * 页面关闭 - 调用此方法关闭 webview 时, 即使 close_alert 为 1, SDK 也不会出确认弹窗
     */
    triggerCloseBtnWithNoConfirm(state = 'click') {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'triggerCloseBtn',
            params: {
                state
            },
            succ: function (res) {
                //document.write(res);
                if (res && util.device().isAndroid) {

                } else {

                }
            },
            err: function () {
                util.tips('Sorry, network error...')
            }
        });
    }
    /**
     * 获取当前进度
     * @param cb
     */
    getCurrentProgress(cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'getCurrentProgress',
            params: {},
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                util.tips('Sorry, network error...')
            }
        })
    }

    /**
     * 设置`视频播放播放器`位置和大小
     * @param params
     * @param cb
     */
    showVideoLocation(params, cb) {
        console.log('showVideoLocation', JSON.stringify(params))
        // util.createEl(JSON.stringify(params) +'_' +(new Date).getTime(), 'showVideoLocation')
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'showVideoLocation',
            params: params,
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 是否关闭Video组件
     * @param close 1关闭video组件，其他值保持不变
     * @param view_visible 关闭按钮1隐藏，2展示，其他值为保持组件内默认值
     * @param cb
     */
    closeVideoOperte(close, view_visible, cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'closeVideoOperte',
            params: {
                close,
                view_visible
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 进度或倒计时控制
     * @param progress 0-100 当前进度，最大值为100 -1不做处理
     * @param view_visible 进度控件1隐藏，2展示，其他值为保持组件内默认值
     * @param cb
     */
    progressOperate(progress, view_visible, cb) {
        // alert('progressOperate: ' + progress)
        // alert('view_visible: ' + view_visible)
        // console.log('progressOperate', progress, view_visible)
        console.log('progressOperate: ', {
            progress,
            view_visible
        })
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'progressOperate',
            params: {
                progress,
                view_visible
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 查询是否在前台
     * @param cb
     */
    isSystemResume(cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'isSystemResume',
            params: {},
            succ: function (res) {
                cb && cb(res)
            },
            err: function () {
                cb && cb('err')
            }
        })
    }

    /**
     * 设置`storekit`位置和大小
     * @param params
     */
    showStorekit(params, cb) {
        console.log('showStorekitRect', JSON.stringify(params))
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'showStorekit',
            params: params,
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 声音
     * @param mute 1为静音 2为不静音
     * @param view_visible 1为隐藏 2为展示
     * @param pt 是否用户手动触发 '1'程序 '2'用户点击
     * @param cb 回调
     */
    soundOperate(mute, view_visible, pt = '1', cb) {
        console.log('soundOperate: ', {
            mute,
            view_visible,
            pt
        })

        util.createEl('soundOperate: ' + JSON.stringify({
            mute,
            view_visible,
            pt
        }))
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'soundOperate',
            params: {
                mute,
                view_visible,
                pt
            },
            succ: function (res) {
                // console.log(typeof res.code)
                if (res.code === 0) {
                    cb && cb(res)
                } else {
                    cb && cb('err', err)
                }
            },
            err: function (err) {
                cb && cb('err', err)
            }
        })
    }

    /**
     * 视频处理
     * @param pause_or_resume 1为播放 2为暂停
     * @param cb
     */
    videoOperate(pause_or_resume, cb) {
        console.log('videoOperate: ', {
            pause_or_resume
        })
        // // alert('pause_or_resume: ' + pause_or_resume)
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'videoOperate',
            params: {
                pause_or_resume
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 关闭`video`组件
     * @param close 1为关闭video组件
     * @param closeViewVisible 关闭按钮 1为隐藏，2展示
     */
    closeVideoOperate(close, closeViewVisible) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'closeVideoOperate',
            params: {
                close,
                closeViewVisible
            },
            succ: function (res) {
                console.log(JSON.stringify(res))
            },
            err: function (err) {
                console.log(JSON.stringify(err))
            }
        })
    }

    /**
     * 点击视频外区域展示`banner` or `miniwebview`
     * @param type
     * -1 都不展示
     * 1为 banner`cta`
     * 2为 `miniendcard`
     * 3为 `VAST`品牌广告浮窗
     * @param cb 回调
     */
    showVideoClickView(type = 1, cb) {
        // alert('showVideoClickView: 无参数')
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'showVideoClickView',
            params: {
                type
            },
            succ: function (res) {
                // console.log(JSON.stringify(res))
                cb && cb(res)
            },
            err: function (err) {
                console.log(JSON.stringify(err))
            }
        })
    }

    /**
     * 发送统计
     * @param param
     * @param cb
     */
    statistics(param, cb) {
        console.log('statistics: ', param)
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'statistics',
            params: param,
            succ: function (res) {
                // console.log(JSON.stringify(res))
                cb && cb(res)
            },
            err: function (err) {
                console.log(JSON.stringify(err))
            }
        })
    }

    /**
     * * 通知Native 视频播放完需要操作处理的业务
     * @param params type ：1 模板4播放完成大图替换播放位置，并且上报`noticeurl` 和 `clickurl`
     * @param cb
     */
    playVideoFinishOperate(params, cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'playVideoFinishOperate',
            params: params,
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 设置全屏
     * @param fitxy: "1表示缩放，其他表示不变"
     * @param cb
     */
    setScaleFitXY(fitxy = 1, cb) {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'setScaleFitXY',
            params: {
                fitxy
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function (err) {
                cb && cb('err')
            }
        })
    }

    /**
     * 处理h5异常，通知sdk
     * @param code
     * @param message
     * @param cb
     */
    handlerH5Exception(code = -1000, message, cb){
        console.log('handlerH5Exception: ', {
            code,
            message
        })
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'handlerH5Exception',
            params: {
                code,
                message
            },
            succ: function (res) {
                cb && cb(res)
            },
            err: function () {
                // util.tips('Sorry, network error...');
            }
        })
    }


    /**
     * 使用外部浏览器, 打开当前提供的 url
     * @param url 要打开的 url 地址
     */
    openUrl (url = '') {
        util.hybirdEvent({
            sClass: this.hybirdEventClass,
            hybirdFn: 'openURL',
            params: {
                type: 1,
                url: url
            },
            succ: function (res) {
                console.log(res)
            },
            err: function (err) {
                console.error(err)
                util.tips('Sorry, network error...');
            }
        })
    }

    /**
     * 获取 SDK RewardJS 的上下文
     * RewardJs 需要注意的版本兼容问题:
     * 1. Android 9.6.0 下根节点有 {campaignList, sdk_info, unit_id, appSetting, unitSetting}, 但没有 {device} 属性
     * 2. Android 8.13.0 下根节点只有 {campaignList, sdk_info, unit_id}, 没有 {appSetting, unitSetting, SDKSetting, device} 属性
     * @param succ 成功回调
     * @param err 失败回调
     * @param complete 无论成功或者失败都会执行的回调
     */
    getRewardJSContext ({succ = ()=>{}, err = ()=>{}, complete = ()=>{}}) {
        util.hybirdEvent({
            sClass: 'RewardJs',
            hybirdFn: 'getEndScreenInfo',
            params: {
                pageNo: 1,
                exclude_ids: []
            },
            succ: function (res) {
                console.log('common: get RewardJS Context success => ', res)
                if (res && res.campaignList && res.campaignList.length) {
                    succ(res)
                } else {
                    util.noDataTips()
                }
                complete(res)
            },
            err: function (err) {
                console.error('common: get RewardJS Context error', err)
                err(err)
                complete(err)
            }
        })
    }



    /**
     * 暂停页面，切换出`app`
     * @param cb
     */
    onSystemPause(cb) {
        document.addEventListener('onSystemPause', function (res) {
            console.log('onSystemPause res: ', res.param)
            cb(res)
        }, false)
    }

    /**
     * 唤醒`app`
     * @param cb
     */
    onSystemResume(cb) {
        document.addEventListener('onSystemResume', function (res) {
            console.log('onSystemResume res: ', res.param)
            cb(res)
        }, false)
    }

    /**
     * 销毁当前页面 不能有回调
     * @param cb
     */
    onSystemDestory(cb) {
        document.addEventListener('onSystemDestory', function (res) {
            console.log('onSystemDestory res: ', res.param)
            cb(res.param)
        }, false)
    }

    /**
     * 视频状态通知监听
     * @param cb
     */
    onVideoStatusNotify(cb) {
        document.addEventListener('onVideoStatusNotify', function (res) {
            cb(res.param)
        }, false)
    }

    /**
     * `sdk`通知`js`点击事件
     * @param cb
     */
    onJSClick(cb) {
        document.addEventListener('onJSClick', function (res) {
            console.log('onJSClick res: ', res.param)
            cb(res.param)
        }, false)
    }

    /**
     * 监听横竖屏旋转
     * @param cb
     * portrait 竖屏，landscape 横屏
     */
    orientation(cb) {
        document.addEventListener('orientation', function (res) {
            cb(res)
        }, false)
    }

    /**
     * 监听安卓的`回退`按钮
     * @param cb
     */
    onSystemBackPressed(cb) {
        document.addEventListener('onSystemBackPressed', function (res) {
            cb && cb(res.param)
        }, false)
    }
    /**
     * ios 展示 storekit 成功或者失败
     * @param cb
     */
    storeKitShowSuccess(cb) {
        document.addEventListener('storeKitShowSuccess', function (res) {
            cb(res.param)
        }, false)
    }

    /**
     * 播放进度通知状态,progress表示当前进度如0.20,time表示当前播放时长单位秒,duration表示总时长
     * @param cb
     */
    onVideoProgressNotify(cb){
        document.addEventListener('onVideoProgressNotify', function (res) {
            cb(res.param)
        }, false)
    }

    /**
     * IOS 主动通知 屏幕宽高和方向
     * @param cb
     */
    showDataInfo(cb){
        document.addEventListener('showDataInfo', function (res) {
            cb(res.param)
        }, false)
    }

}





